import { render, staticRenderFns } from "./QuestionarioDinamico.vue?vue&type=template&id=f32d7fa8&scoped=true"
import script from "./QuestionarioDinamico.vue?vue&type=script&lang=js"
export * from "./QuestionarioDinamico.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioDinamico.vue?vue&type=style&index=0&id=f32d7fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32d7fa8",
  null
  
)

export default component.exports